export default __webpack_public_path__ + "static/media/lei.962dc3af.svg";